import { configureStore, combineReducers } from "@reduxjs/toolkit";
import authReducer from "./slices/authSlice";
import dashboardReducer from "./slices/dashboardSlice";
import usersReducer from "./slices/usersSlice";
import chatsReducer from "./slices/chatsSlice";
import supportChatsReducer from "./slices/supportChatsSlice";
import messagesReducer from "./slices/messagesSlice";
import chatHistoryReducer from "./slices/chatHistorySlice";
import {
  templatesReducer,
  recipientsReducer,
  emailCompositionReducer,
  emailStatsReducer,
  groupsReducer,
} from "./slices/bulkEmailSlice";
import userTrackingReducer from "./slices/userTrackingSlice";

const bulkEmailReducer = combineReducers({
  templates: templatesReducer,
  recipients: recipientsReducer,
  emailComposition: emailCompositionReducer,
  emailStats: emailStatsReducer,
  groups: groupsReducer,
});

export const store = configureStore({
  reducer: {
    auth: authReducer,
    dashboard: dashboardReducer,
    users: usersReducer,
    chats: chatsReducer,
    supportChats: supportChatsReducer,
    messages: messagesReducer,
    chatHistory: chatHistoryReducer,
    bulkEmail: bulkEmailReducer,
    userTracking: userTrackingReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["persist/PERSIST"],
      },
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
